import { render } from "./xqc-reprint-table.vue?vue&type=template&id=05f53664&scoped=true"
import script from "./xqc-reprint-table.vue?vue&type=script&lang=ts"
export * from "./xqc-reprint-table.vue?vue&type=script&lang=ts"

import "./xqc-reprint-table.vue?vue&type=style&index=0&id=05f53664&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-05f53664"

export default script